import { PayloadAction } from "@reduxjs/toolkit";
import { StaffDataState } from "module/staff/redux/types";
import { EntityIdentifier } from "module/entity/types";
import { getEntityIdentifierKey } from "module/entity/helper/getEntityIdentifierKey";
import moment from "moment/moment";
import { API_DATE_TIME_FORMAT } from "../../../../api/date";

interface OpenItemActionTypeProps {
  staffId: number;
  systemShortName: string;
  entityIdentifier: EntityIdentifier;
}

const openEntityAction = (
  state: StaffDataState,
  action: PayloadAction<OpenItemActionTypeProps>
): void => {
  const { staffId, systemShortName, entityIdentifier } = action.payload;
  state[staffId][systemShortName].openEntityIdentifiers = [
    ...(state[staffId][systemShortName].openEntityIdentifiers ?? []),
    entityIdentifier,
  ];

  if (
    "openCloseHistory" in
    state[staffId][systemShortName].entities[
      getEntityIdentifierKey(entityIdentifier)
    ].data
  ) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { openCloseHistory } =
      state[staffId][systemShortName].entities[
        getEntityIdentifierKey(entityIdentifier)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
      ].data;

    openCloseHistory.push({
      type: "open",
      staffId,
      dateTime: moment().format(API_DATE_TIME_FORMAT),
    });

    state[staffId][systemShortName].entities[
      getEntityIdentifierKey(entityIdentifier)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
    ].data.openCloseHistory = openCloseHistory;
  }
};

export default openEntityAction;
